export interface IE2ETestCase {
  name: string;
  displayName: string;
  description: string;
  category: string;
  timeoutMinutes: number;
}

export interface IListE2eTestsResponse {
  listE2eTests: IE2ETestCase[];
}

export const listE2eTestsQuery = `
  query {
    listE2eTests {
      name
      displayName
      description
      category
      timeoutMinutes
    }
  }
`;
